import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";
import {BoolLike} from "../../../../../../models";

// HTB details live on the requirement only (nothing is read from the HTB document)
export const htbQuestions = () => [
    {
        label: "Using HTB Scheme",
        name: 'helpToBuyScheme',
        answer: {
            type: "select",
            choices: [
                {
                    text: "Yes",
                    value: BoolLike.TRUE
                },
                {
                    text: "No",
                    value: BoolLike.FALSE
                },
                {
                    text: "Don't know",
                    value: BoolLike.NOTSURE
                }
            ]
        },
        target: `requirement.helpToBuyScheme`
    },
    {
        name: 'helpToBuySchemeAmount',
        label: "Amount Receiving",
        answer: {
            type: "euro",
        },

        target: `requirement.helpToBuySchemeAmount`,
    },
    {
        name: 'helpToBuySchemeAccessCode',
        label: "Access Code",
        answer: {
            type: "text",
        },

        target: `requirement.helpToBuySchemeAccessCode`,
    },
    {
        name: 'helpToBuySchemeApplicationCode',
        label: "Application Code",
        answer: {
            type: "text",
        },

        target: `requirement.helpToBuySchemeApplicationCode`,
    },
    {
        label: "Developer Name",
        answer: {
            type: "text",
        },
        name: 'helpToBuySchemeDeveloperName',
        target: `requirement.helpToBuySchemeDeveloperName`,
    },
    {
        name: 'helpToBuyExpiryDate',
        label: "Expiry Date",
        answer: {
            type: "date",
        },
        target: `requirement.helpToBuyExpiryDate`,
    }
]

function ApplicationForm({section, inExtWindow=true}) {
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={htbQuestions()}/>
    );
}

export default ApplicationForm;